import { NextPage } from 'next';
import { GetStaticProps, GetStaticPaths } from 'next';
import Podcasts from '@/components/screens/podcasts/Podcasts';
import useRedirectToFirstPage from '@/hooks/useRedirectToFirstPage';
import { BOOKS_FOR_PAGE, PRERENDER_PAGES, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { getPagesNumbersPaths } from '@/helpers/helpers';
import { IPodcastsPage } from '@/interfaces/podcastsPage.interface';

const PodcastsVisitedPageDynamic: NextPage<IPodcastsPage> = ({ books }) => {
  useRedirectToFirstPage('/podcasts/sorting/visited/');
  return <Podcasts books={books} sortingName="по просмотрам" sortingUrl={'sorting/visited'} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;
  const res = await fetch(`${API_URL}satellite/podcast/podcast?page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}&sort_field=views_count&sort_reversed=true`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default PodcastsVisitedPageDynamic;
